const translations = {

        "no_pending_orders": "אין הזמנות שמחכות לאישור",
        "approve_order": "אשר הזמנה",
        "cancel_order": "בטל הזמנה",
        "ordersAwaitingYourApproval": "הזמנות שמחכות לאישורך"    
};

export default translations;